import { Button, Container, Toolbar, Typography } from '@mui/material'
import { Header } from 'presentation/header/header'
import construction from '../assets/construction.svg'
import { useTranslation } from 'react-i18next'

/**
 * A page that is displayed when a page is not found.
 * @category General
 */
export function NotFoundPage() {
  const { t } = useTranslation()
  return <ErrorPage msg={t('page_not_exist')} />
}

/**
 * A page that is displayed when an error occurs.
 * @param props
 * @param props.msg
 * @param props.details
 * @category General
 */
export function ErrorPage(props: { msg: string; details?: string }) {
  const { msg, details } = props
  let message: string
  if (msg == 'Failed to fetch') {
    message =
      'Die Informationen konnten nicht geladen werden. Bitte prüfe deine Internetverbindung.'
  } else if (msg == 'Could not verify JWT: JWTExpired') {
    message = 'Deine Sitzung ist abgelaufen. Bitte lade die Seite neu.'
  } else if (details?.includes('ChunkLoadError')) {
    message =
      'Es steht ein Update zur Verfügung. Bitte lade die Seite neu, um die neue Version zu laden. Falls das Problem danach weiterhin besteht, wende dich gerne an uns.'
  } else {
    message = msg
  }
  return (
    <>
      <Header />
      <Toolbar />
      <Container maxWidth='md' sx={{ my: 2 }}>
        <img
          style={{
            height: '50vh',
            maxHeight: '200px',
            maxWidth: '100%',
            objectFit: 'contain',
            margin: '1rem 0',
          }}
          src={construction}
        />
        <Typography variant='subtitle1'>{location.href}</Typography>
        <Typography variant='h3' sx={{ mb: 1 }}>
          {message}
        </Typography>
        <Button variant={'contained'} onClick={() => location.reload()}>
          Erneut versuchen
        </Button>
        <Button onClick={() => (location.href = '/')}>Zur Startseite</Button>
        <p>
          <small>{details}</small>
        </p>
      </Container>
    </>
  )
}
